<template>
  <v-app>
    <Loading v-show="loading" />
    <v-container v-show="!loading">
      <v-row dense>
        <v-col cols="12">
          <v-container>
            <v-row>
              <v-col cols="1">
                <v-btn icon @click="$router.go(-1)">
                  <v-icon color="blue">
                    mdi-arrow-left
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
          <v-container>
            <v-row>
              <v-col class="text-left text-caption grey-text">
                <div v-if="currentCourse !== null">
                  {{ currentCourse.courseName }} > {{ currentUnit.unitTitle }}
                </div>
              </v-col>
            </v-row>
          </v-container>
          <v-list v-if="lessons !== null">
            <template v-for="(lesson, index) in lessons">
              <v-divider :key="index" />
              <v-list-item v-if="!lesson.isReference" :key="lesson.masterId" class="my-1" @click="transitLesson(lesson)">
                <v-list-item-icon>
                  <div>
                    <v-icon color="grey lighten-1">
                      mdi-pencil-outline
                    </v-icon>
                  </div>
                </v-list-item-icon>
                <v-list-item-content class="text-left">
                  <v-list-item-title v-if="lesson.lessonNumber !== null" class="wrap-text mt-2" v-text="`${lesson.lessonNumber} | ${lesson.lessonTitle}`" />
                  <v-list-item-title v-if="lesson.lessonNumber === null" class="wrap-text mt-2" v-text="`${lesson.lessonTitle}`" />
                  <v-list-item-subtitle v-text="`再生時間 ： ${lesson.videoLength}`" />
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="lesson.urlRef" :key="lesson.masterId" class="my-1" target="_blank" :href="lesson.urlRef">
                <v-list-item-icon>
                  <div>
                    <v-icon color="grey lighten-1">
                      mdi-web
                    </v-icon>
                  </div>
                </v-list-item-icon>
                <v-list-item-content class="text-left">
                  <v-list-item-title v-if="lesson.lessonNumber !== null" class="wrap-text mt-2" v-text="`${lesson.lessonNumber} | ${lesson.lessonTitle}`" />
                  <v-list-item-title v-if="lesson.lessonNumber === null" class="wrap-text mt-2" v-text="`${lesson.lessonTitle}`" />
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="lesson.isReference && !lesson.urlRef" :key="lesson.masterId" class="my-1" @click="downloadFile($event, lesson)">
                <v-list-item-icon>
                  <div>
                    <v-icon color="grey lighten-1">
                      mdi-file-outline
                    </v-icon>
                  </div>
                </v-list-item-icon>
                <v-list-item-content class="text-left">
                  <v-list-item-title v-if="lesson.lessonNumber !== null" class="wrap-text mt-2" v-text="`${lesson.lessonNumber} | ${lesson.lessonTitle}`" />
                  <v-list-item-title v-if="lesson.lessonNumber === null" class="wrap-text mt-2" v-text="`${lesson.lessonTitle}`" />
                  <v-list-item-subtitle v-if="lesson.notice !== null" class="wrap-text" v-text="`${lesson.notice}`" />
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-divider />
            <v-list-item v-if="currentUnit.isIntroduction === false" class="my-1" :disabled="examStatus.qualify === 2" @click="transitTest(currentUnit)">
              <v-list-item-icon>
                <v-icon color="grey lighten-1">
                  mdi-clipboard-edit-outline
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content v-if="examStatus" class="text-left">
                <v-list-item-title class="wrap-text">
                  第{{ currentUnit.systemUnitNumber }}単元 確認テスト
                </v-list-item-title>
                <v-list-item-subtitle v-if="examStatus.qualify !== 1" class="wrap-text">
                  残り受験可能回数：{{ remainCount }}回
                  <v-list-item-subtitle v-if="remainCount === 0">
                    不合格
                  </v-list-item-subtitle>
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="examStatus.qualify === 1" class="wrap-text">
                  合格
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import axios from 'axios'
import store from '@/store/store'
import repository from '@/store/repository'
import Loading from '@/components/common/Loading'
import handleApiError from '@/plugins/handleApiError'

export default {
  name: 'LessonList',
  components: {
    Loading
  },
  data () {
    return {
      loading: false,
      units: require(`@/assets/courseData/courseUnits/${this.$route.params.courseId}.json`),
      lessons: require(`@/assets/courseData/courseSections/${this.$route.params.courseId}/unit${this.$route.params.unitId}.json`),
      currentUnit: null,
      currentCourse: null,
      examStatus: { qualify: 0 }
    }
  },
  computed: {
    isExamAvailable: function () {
      // nullチェック
      if (!this.examStatus) return false
      // 3回以上受験できない
      if (!this.examStatus.examCount >= 3) return false
      // 合格していたら受験できない
      if (!this.examStatus.qualify === 1) return false

      return true
    },
    ...mapState(['user']),
    remainCount: function () {
      return 3 - this.examStatus.examCount
    }
  },
  async created () {
    const courseId = this.$route.params.courseId
    const courseData = require('@/assets/courseData/courseCards.json')
    this.currentUnit = this.units.find((unit) => unit.systemUnitNumber === parseInt(this.$route.params.unitId))
    this.currentCourse = courseData.find((course) => course.systemName === courseId)
  },
  mounted: async function () {
    this.loading = true
    await this.checkCompletionTest()
    this.loading = false
  },
  methods: {
    ...mapActions(['setCurrentLesson', 'setCurrentUnit']),
    transitTest (unit) {
      this.setCurrentUnit(unit)
      this.$router.push('unit-test')
    },
    transitLesson (lesson) {
      this.setCurrentLesson(lesson)
      this.$router.push('lesson')
    },
    async downloadFile (e, lesson) {
      e.preventDefault()
      for await (const courseMaterial of lesson.courseMaterialRef) {
        const link = document.createElement('a')
        link.href = require('@/assets/courseMaterials/' + this.$route.params.courseId + '/' + courseMaterial)
        link.download = courseMaterial
        link.click()
      }
    },
    async checkCompletionTest () {
      const reqUrl = process.env.VUE_APP_CHECK_COMPLETION_API_URL
      const reqBody = {
        checkType: 'unit',
        pjmUserId: String(repository.getPjmUserId()),
        cognitoUsername: store.state.username,
        cognitoIdToken: repository.getIdToken(),
        courseId: String(this.currentCourse.courseId),
        unitNum: String(this.currentUnit.systemUnitNumber)
      }
      const header = {
        headers: {
          'x-api-key': process.env.VUE_APP_DB_API_KEY,
          'Content-Type': 'application/json',
          Authorization: repository.getAccessToken()
        }
      }

      const res = await axios.post(reqUrl, reqBody, header).catch(handleApiError)

      this.examStatus = res.data
    }
  }
}
</script>
<style scoped>
.wrap-text {
  word-break: break-all;
  white-space: normal;
}
</style>
